const getComparableTerm = (term: string) => term.trim().replace(/\s+/g, ' ').toLocaleLowerCase()

export const normalizeRecordsPdfAdHocTerm = (term: string): string => term.trim().replace(/\s+/g, ' ')

export const hasRecordsPdfAdHocTerm = (terms: readonly string[], candidate: string): boolean => {
  const comparableCandidate = getComparableTerm(candidate)
  return Boolean(comparableCandidate) && terms.some((term) => getComparableTerm(term) === comparableCandidate)
}

export const mergeRecordsPdfRedactionTerms = (...termGroups: readonly (readonly string[])[]): string[] => {
  const seenTerms = new Set<string>()
  const mergedTerms: string[] = []

  termGroups.flat().forEach((term) => {
    const trimmedTerm = term.trim()
    const comparableTerm = getComparableTerm(trimmedTerm)
    if (!comparableTerm || seenTerms.has(comparableTerm)) return

    seenTerms.add(comparableTerm)
    mergedTerms.push(trimmedTerm)
  })

  return mergedTerms
}
